import { TranslateModule } from '@ngx-translate/core';
import { Maybe, Role, Site } from '@iss/libs/graphql';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { ServiceLocationInputComponent } from '../service-location-input';

import {
  LabelDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  Control,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-service-location-field',
  templateUrl: './service-location-field.component.html',
  standalone: true,
  imports: [
    AsyncPipe,
    FormFieldComponent,
    FormFieldErrorDirective,
    LabelDirective,
    NgIf,
    ReactiveFormsModule,
    ServiceLocationInputComponent,
    TranslateModule,
  ],
})
export class ServiceLocationFieldComponent {
  @Input() public readonly: Maybe<boolean>;
  @Input() public loading: Maybe<boolean>;
  @Input() public forceTypeahead: Maybe<boolean>;
  @Input() public label: Maybe<string>;
  @Input() public placeholder: Maybe<string>;
  @Input() public siteId: Maybe<Site['id']>;
  @Input() public showNecessity = true;
  @Input() public withAll: Maybe<boolean>;
  @Input() public role: Maybe<Role>;
  @Input() public clearable = true;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
